// extracted by mini-css-extract-plugin
export default {"_hy":"_hy","rakutenSisters":"rakutenSisters-module_rakutenSisters_Z2A","container":"rakutenSisters-module_container_Zzm","icon":"rakutenSisters-module_icon_6LT"};